/* eslint-disable no-console */

import { register } from "register-service-worker";
import { showMessage } from "@/services/MessageService";

if (
  process.env.NODE_ENV === "production" &&
  ("https:" === location.protocol ||
    location.host.match(/(localhost|127.0.0.1)/)) &&
  navigator.serviceWorker
) {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        "App is being served from cache by a service worker.\n" +
          "For more details, visit https://goo.gl/AFskqB"
      );
    },
    registered() {
      console.log("Service worker has been registered.");
    },
    cached() {
      console.log("Content has been cached for offline use.");
    },
    updatefound() {
      console.log("New content is downloading.");
    },
    updated() {
      console.log("New content is available; please refresh.");
    },
    offline() {
      showMessage({
        message:
          "No se encontró conexión a internet, la aplicación está corriendo en modo offline.",
        color: "info"
      });
    },
    error(error) {
      console.error("Error during service worker registration:", error);
    }
  });
}
